export const utilityMixin = {
    data () {
        return {
            dayOfWeekStr: [ '日', '月', '火', '水', '木', '金', '土' ]
        };
    },
    created () {
    },
    methods: {
        /** ----------------------------------------------
         * 日付文字列取得
         * 引数を文字列（YYYY-MM-DD）に編集する。
         * 引数がnullの場合は現在日を編集する。
         * @param  {Date} date 日付
         * @return {String} 日付文字列（YYYY-MM-DD）
         * ---------------------------------------------- */
        getDateStr (date) {
            var targetDate;
            if (date == null) {
                targetDate = new Date();
            } else {
                targetDate = new Date(date);
            }
            var targetDateStr =
                    targetDate.getFullYear() + '-' +
                    ('0' + (targetDate.getMonth() + 1)).slice(-2) + '-' +
                    ('0' + targetDate.getDate()).slice(-2);
            return targetDateStr;
        },
        /** ----------------------------------------------
         * 日付文字列取得
         * 引数を文字列（YYYY年MM月DD日）に編集する
         * 引数がnullの場合は現在日を編集する。
         * @param  {Date} date 日付
         * @return {String} 日付文字列（YYYY年MM月DD日）
         * ---------------------------------------------- */
        getDateStrJapanese (date) {
            var targetDate;
            if (date == null) {
                targetDate = new Date();
            } else {
                targetDate = date;
            }
            var targetDateStr =
                    targetDate.getFullYear() + '年' +
                    ('0' + (targetDate.getMonth() + 1)).slice(-2) + '月' +
                    ('0' + targetDate.getDate()).slice(-2) + '日';
            return targetDateStr;
        },
        /** ----------------------------------------------
         * 日付文字列取得
         * 引数を文字列（YYYY年MM月DD日）に編集し01月を1月の表記で取得する
         * 引数がnullの場合は現在日を編集する。
         * @param  {Date} date 日付
         * @return {String} 日付文字列（YYYY年MM月DD日）
         * ---------------------------------------------- */
        getDateBindStrJapanese (date) {
            var targetDate;
            if (date == null) {
                targetDate = new Date();
            } else {
                targetDate = date;
            }
            var targetDateStr =
                    targetDate.getFullYear() + '年' +
                    Number(('0' + (targetDate.getMonth() + 1)).slice(-2)) + '月' +
                    Number(('0' + targetDate.getDate()).slice(-2)) + '日';
            return targetDateStr;
        },
        /** ----------------------------------------------
         * 時刻文字列取得
         * 引数を文字列（H:MM）に編集する（時は0サプライしない）
         * 引数がnullの場合は現在時刻を編集する。
         * @param  {String} time 時刻(HH:MM:SS)
         * @return {String} 時刻文字列（H:MM）
         * ---------------------------------------------- */
        getTimeStr (time) {
            var workDate;
            if (time == null) {
                workDate = new Date();
            } else {
                workDate = new Date('2020-01-01 ' + time);
            }

            var targetTimeStr =
                    workDate.getHours() + ':' +
                    ('0' + (workDate.getMinutes())).slice(-2);

            return targetTimeStr;
        },
        /** ----------------------------------------------
         * 時刻文字列取得
         * 引数を文字列（H時MM分）に編集する（時は0サプライしない）
         * 引数がnullの場合は現在時刻を編集する。
         * @param  {String} time 時刻(HH:MM:SS)
         * @return {String} 時刻文字列（H時MM分）
         * ---------------------------------------------- */
        getTimeStrJapanese (time) {
            var workDate;
            if (time == null) {
                workDate = new Date();
            } else {
                workDate = new Date('2020-01-01 ' + time);
            }

            var targetTimeStr =
                    workDate.getHours() + '時' +
                    ('0' + (workDate.getMinutes())).slice(-2) + '分';

            return targetTimeStr;
        },
        /** ----------------------------------------------
         * 曜日取得
         * 曜日を取得する
         * 引数がnullの場合は現在日の曜日を取得する
         * @param  {Date} date 日付
         * @return {String} 曜日
         * ---------------------------------------------- */
        getDayJapanese (date) {
            var targetDate;
            if (date == null) {
                targetDate = new Date();
            } else {
                targetDate = date;
            }

            return this.dayOfWeekStr[targetDate.getDay()];
        },
        /** ----------------------------------------------
         * GraghQLで投げられるエラーメッセージを取得する。 例: "graghql Error: エラーメッセージ"
         * ---------------------------------------------- */
        getGraghQLErrorMessage (error) {
            const message = error.message.split(/:/);
            return message[1];
        },
        deleteKeyDelete (event) {
            event.target.value = this.formatDate(event.target.value);
            return event.target.value;
        },
        formatDate (pdate) {
            let rdate = pdate;
            const regex = /-/g;
            const h = pdate.match(regex);
            if (!h) {
                if (pdate.length === 4) {
                    rdate = pdate + '-';
                }
            } else if (h.length === 1) {
                const position = pdate.indexOf('-');
                if (position === 4) {
                    if (pdate.length === 7) {
                        rdate = pdate + '-';
                    } else if (position === 4 && pdate.length === 8) {
                        rdate = this.replaceHyphen(pdate, 7);
                    } else if (position === 4 && pdate.length === 9) {
                        rdate = this.replaceHyphen(pdate, 7);
                    }
                } else if (position === 6 && pdate.length === 9) {
                    rdate = this.replaceHyphen(pdate, 4);
                }
            }
            return rdate;
        },
        focusDate (pdate) {
            let rdate = pdate;
            let date = pdate.split(/-/g);
            let [year, month, day] = date;
            if (!day && year.length === 4) {
                if (month && month.length === 2) {
                    date.splice(3, 0, '-');
                }
                date.splice(1, 0, '-');
                rdate = date.join('');
            }
            return rdate;
        },
        replaceHyphen (str, index) {
            str = str.slice(0, index) + '-' + str.slice(index);
            return str;
        },
        addHyphen (pdate) {
            let rdate = pdate;
            let date = pdate.split(/-/g);
            let [year, month, day] = date;
            if (!day && year.length === 4) {
                if (month && month.length === 2) {
                    date.splice(3, 0, '-');
                }
                date.splice(1, 0, '-');
                rdate = date.join('');
            } else if (year.length > 4 && date.length <= 10) {
                year = this.replaceHyphen(year, 4);
                date.splice(0, 1, year);
                rdate = date.join('');
            }
            return rdate;
        },
        formatFee (str) {
            var wnum = String(str).replace(/,/g, '');
            var re = /^[0-9]*$/;
            var answer = re.test(wnum);
            if (answer && Number(wnum) >= 1) {
                var wstr = Number(wnum);
                return wstr.toLocaleString();
            } else if (str) {
                return str;
            } else {
                return '';
            }
        },
        formatFoucsFee (str) {
            return String(str).replace(/,/g, '');
        },
        formatBlurFee (str) {
            var wnum = String(str).replace(/,/g, '');
            if (str.length >= 1 && wnum >= 1) {
                return Number(wnum).toLocaleString();
            } else {
                return str;
            }
        },
        /** ----------------------------------------------
         * 月の末尾を取得する。
         * ---------------------------------------------- */
        getLastDay (year, month) {
            return new Date(year, month, 0).getDate();
        },
        /** ----------------------------------------------
         * 当日の日付を取得する。
         * 例 2020-12-12
         * ---------------------------------------------- */
        getToday () {
            const today = new Date();
            const y = today.getFullYear();
            let m = today.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            let d = today.getDate();
            d = d < 10 ? '0' + d : d;
            return y + '-' + m + '-' + d;
        },
        /** --------------------------------------------
        * 指定した日数分の日付一覧を取得する
        * @param  {Int} days 取得する日数
        * @param  {String} setDay 開始日付 例："2020-01-28"
        *                         (nullであれば当日から取得される)
        * @return {Array} dayList 日付一覧
        * -------------------------------------------- */
        getSettingDayList (days, setDay) {
            var today = null;
            var dayList = [];
            if (setDay) {
                var dayArray = setDay.split('-');
                var setYear = Number(dayArray[0]);
                var setMonth = Number(dayArray[1]);
                var setDate = Number(dayArray[2]);
                today = new Date(setYear, setMonth - 1, setDate);
            } else {
                today = new Date();
            }
            const todayYear = today.getFullYear();
            let todayMonth = today.getMonth() + 1;
            let todayDate = today.getDate();
            for (var i = 0; i < days; i++) {
                var day = new Date(todayYear, todayMonth - 1, todayDate + i);
                const y = day.getFullYear();
                let m = day.getMonth() + 1;
                m = m < 10 ? '0' + m : m;
                let d = day.getDate();
                d = d < 10 ? '0' + d : d;
                dayList.push(y + '-' + m + '-' + d);
            }
            return dayList;
        },
        /** ----------------------------------------------
         * 半角カタカナを全角カタカナに変換する。
         * @param  {String} val 変換対象の文字
         * @return {String} 変換後の文字
         * ---------------------------------------------- */
        hankanaChangeZenkana (val) {
            var kanaMap = {
                'ｶﾞ': 'ガ',
                'ｷﾞ': 'ギ',
                'ｸﾞ': 'グ',
                'ｹﾞ': 'ゲ',
                'ｺﾞ': 'ゴ',
                'ｻﾞ': 'ザ',
                'ｼﾞ': 'ジ',
                'ｽﾞ': 'ズ',
                'ｾﾞ': 'ゼ',
                'ｿﾞ': 'ゾ',
                'ﾀﾞ': 'ダ',
                'ﾁﾞ': 'ヂ',
                'ﾂﾞ': 'ヅ',
                'ﾃﾞ': 'デ',
                'ﾄﾞ': 'ド',
                'ﾊﾞ': 'バ',
                'ﾋﾞ': 'ビ',
                'ﾌﾞ': 'ブ',
                'ﾍﾞ': 'ベ',
                'ﾎﾞ': 'ボ',
                'ﾊﾟ': 'パ',
                'ﾋﾟ': 'ピ',
                'ﾌﾟ': 'プ',
                'ﾍﾟ': 'ペ',
                'ﾎﾟ': 'ポ',
                'ｳﾞ': 'ヴ',
                'ﾜﾞ': 'ヷ',
                'ｦﾞ': 'ヺ',
                'ｱ': 'ア',
                'ｲ': 'イ',
                'ｳ': 'ウ',
                'ｴ': 'エ',
                'ｵ': 'オ',
                'ｶ': 'カ',
                'ｷ': 'キ',
                'ｸ': 'ク',
                'ｹ': 'ケ',
                'ｺ': 'コ',
                'ｻ': 'サ',
                'ｼ': 'シ',
                'ｽ': 'ス',
                'ｾ': 'セ',
                'ｿ': 'ソ',
                'ﾀ': 'タ',
                'ﾁ': 'チ',
                'ﾂ': 'ツ',
                'ﾃ': 'テ',
                'ﾄ': 'ト',
                'ﾅ': 'ナ',
                'ﾆ': 'ニ',
                'ﾇ': 'ヌ',
                'ﾈ': 'ネ',
                'ﾉ': 'ノ',
                'ﾊ': 'ハ',
                'ﾋ': 'ヒ',
                'ﾌ': 'フ',
                'ﾍ': 'ヘ',
                'ﾎ': 'ホ',
                'ﾏ': 'マ',
                'ﾐ': 'ミ',
                'ﾑ': 'ム',
                'ﾒ': 'メ',
                'ﾓ': 'モ',
                'ﾔ': 'ヤ',
                'ﾕ': 'ユ',
                'ﾖ': 'ヨ',
                'ﾗ': 'ラ',
                'ﾘ': 'リ',
                'ﾙ': 'ル',
                'ﾚ': 'レ',
                'ﾛ': 'ロ',
                'ﾜ': 'ワ',
                'ｦ': 'ヲ',
                'ﾝ': 'ン',
                'ｧ': 'ァ',
                'ｨ': 'ィ',
                'ｩ': 'ゥ',
                'ｪ': 'ェ',
                'ｫ': 'ォ',
                'ｯ': 'ッ',
                'ｬ': 'ャ',
                'ｭ': 'ュ',
                'ｮ': 'ョ',
                '｡': '。',
                '､': '、',
                'ｰ': 'ー',
                '｢': '「',
                '｣': '」',
                '･': '・'
            };

            var reg = new RegExp('(' + Object.keys(kanaMap).join('|') + ')', 'g');
            return val.replace(reg, function (match) { return kanaMap[match]; }).replace(/ﾞ/g, '゛').replace(/ﾟ/g, '゜');
        }
    }
};
